import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export class MajorProgram implements IIndexable {
  id: number;
  nk: string;
  cd: string;
  cat_year: number;
  name: string;
  desc: string;
  credits: number;
  area_of_study: string;
  credential: string;
  credential_id: number;
  short_credential: string;
  rank: number;
  min_dev_course: number;
  hiring_demand: string;
  salary_trend_min_raw: number;
  salary_trend_max_raw: number;
  salary_trend_min: string;
  salary_trend_max: string;
  bachelor_salary_trend_min: string;
  bachelor_salary_trend_max: string;
  masters_salary_trend_min: string;
  masters_salary_trend_max: string;
  salary_trend_average: string;
  salary_trend_real_time_min: string;
  salary_trend_real_time_max: string;
  salary_trend_real_time_average: string;
  estimated_tuition: string;
  student_program_activity: any[];
  student_program_subject: any[];
  is_favorite: boolean;
  favorite_id: number;
  _chosen: boolean;
  _opened: boolean;
  _in_state_tuition: number;
  _has_salary_information: boolean;
  _has_masters_salary_information: boolean;
  _has_bachelor_salary_information: boolean;
  _interests: any[];
  _dev_req_array: any[];
  _has_dev_req: boolean;
  _has_no_dev_req: boolean;
  _search_string: string;
  _has_interests: boolean;
  isCurrentMajor: boolean;
  hiringTrend: any;
  _hiring_demand_ranking: number;
  _isUpdating: boolean;

  constructor(program: Partial<MajorProgram>) {
    _4.merge(this, program);
  }

  static build(program: Partial<MajorProgram>): MajorProgram {
    return new MajorProgram(program);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/builders/major_programs_builder.ts